import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

/**
 * Client-side route guard for RBAC navigation. API endpoints must enforce the
 * same policy on the server; this component only prevents invalid UI access.
 */
function RequireRole({ allowedRoles, deniedRoles = [], children }) {
  const accountType = useSelector(
    (state) => state.userData.loginData.account_type,
  );

  const isAllowed =
    (!allowedRoles || allowedRoles.includes(accountType)) &&
    !deniedRoles.includes(accountType);

  return isAllowed ? children : <Navigate to="/" replace />;
}

export default RequireRole;
